<template>
  <div>
    <div class="form-container">
      <ProgressBar :progressPercent="100" progressLabel="Step 5 of 5" />
      <h1 class="step-title">Dwelling Limits</h1>

      <div class="row">
        <div class="col-md-4">
          <label for="dwelling_amount">Dwelling Amount</label>
          <input
            type="text"
            class="form-control shadow-none"
            id="dwelling_amount"
            placeholder="$450,000 USD"
            :value="five.dwelling_amount"
            @input="updateCurrency('dwelling_amount', $event.target.value)"
          />
        </div>

        <div class="col-md-4">
          <label for="contents">Contents</label>
          <input
            type="text"
            class="form-control shadow-none select"
            id="contents"
            :value="five.contents"
            @input="updateCurrency('contents', $event.target.value)"
            placeholder="$25,000 USD"
          />
        </div>

        <div class="col-md-4">
          <label for="burglary">Burglary</label>
          <input
            type="text"
            class="form-control shadow-none select"
            id="burglary"
            :value="five.burglary"
            @input="updateCurrency('burglary', $event.target.value)"
            placeholder="$25,000 USD"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label for="loss_of_rents">Loss of Rents</label>
          <select
            id="loss_of_rents"
            class="form-control shadow-none select"
            @change="updateField('loss_of_rents', $event.target.value)"
          >
            <option :selected="five.loss_of_rents" value="true">Yes</option>
            <option :selected="!five.loss_of_rents" value="false">No</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="liabilty">Liability</label>
          <input
            type="text"
            class="form-control shadow-none select"
            id="liability"
            :value="five.liability"
            @input="updateCurrency('liability', $event.target.value)"
            placeholder="$300,000 USD"
            v-mask="'$###,###'"
          />
        </div>

        <div class="col-md-4">
          <label for="valuable_items">Valuable Items</label>
          <input
            type="text"
            class="form-control shadow-none select"
            id="valuable_items"
            :value="five.valuable_items"
            @input="updateCurrency('valuable_items', $event.target.value)"
            placeholder="$10,000 USD"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label for="money">Money &amp; Securities</label>
          <input
            type="text"
            class="form-control"
            id="money"
            placeholder="$15,000 USD"
            :value="five.money_securities"
            @input="updateCurrency('money_securities', $event.target.value)"
          />
        </div>
        <div class="col-md-4">
          <label for="glass">Glass Breakage</label>
          <input
            type="text"
            class="form-control"
            id="glass"
            placeholder="$5,000 USD"
            :value="five.glass_breakage"
            @input="updateCurrency('glass_breakage', $event.target.value)"
          />
        </div>
        <div class="col-md-4">
          <label for="electronics">Electronics</label>
          <input
            type="text"
            class="form-control"
            id="electronics"
            placeholder="$8,000 USD"
            :value="five.electronics"
            @input="updateCurrency('electronics', $event.target.value)"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label>Outdoor Property</label>
          <div
            v-for="(property, idx) in outdoor_property"
            class="outdoor-properties__item"
            :key="idx"
          >
            <input
              class="form-control"
              type="text"
              placeholder="Name"
              @input="updatePropertyName(idx, $event.target.value)"
              :value="property.name"
            />
            <input
              type="text"
              class="form-control"
              :value="property.amount"
              @input="updatePropertyAmount(idx, $event.target.value)"
              placeholder="$50,000 USD"
            />
            <button
              type="button"
              class="btn btn-default"
              @click="removeProperty(idx)"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div class="outdoor_properties__add_btn_container">
            <button class="btn btn-default" @click="addProperty">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label>Other Structures</label>
          <div
            v-for="(structure, idx) in other_structures"
            class="other-structures__item"
            :key="idx"
          >
            <input
              class="form-control"
              type="text"
              placeholder="Name"
              @input="updateStructureName(idx, $event.target.value)"
              :value="structure.name"
            />
            <input
              type="text"
              class="form-control"
              :value="structure.amount"
              @input="updateStructureAmount(idx, $event.target.value)"
              placeholder="$50,000 USD"
            />
            <button
              type="button"
              class="btn btn-default"
              @click="removeStructure(idx)"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div class="other_structures__add_btn_container">
            <button class="btn btn-default" @click="addStructure">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label>Loss History</label>
          <div
            v-for="(loss, idx) in loss_history"
            class="loss-history__item"
            :key="idx"
          >
            <input
              class="form-control"
              type="text"
              placeholder="Type of Loss"
              @input="updateLossHistoryType(idx, $event.target.value)"
              :value="loss.type"
            />
            <input
              type="text"
              class="form-control"
              :value="loss.amount"
              @input="updateLossHistoryAmount(idx, $event.target.value)"
              placeholder="$50,000 USD"
            />
            <input
              type="date"
              class="form-control"
              :value="loss.date"
              @input="updateLossHistoryDate(idx, $event.target.value)"
              placeholder="date"
            />
            <button
              type="button"
              class="btn btn-default"
              @click="removeLossHistoryItem(idx)"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div class="outdoor_properties__add_btn_container">
            <button class="btn btn-default" @click="addLossHistoryItem">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label>Utility Bill Upload (PDF)</label>
          <FileUploader
            :localName="uploadedFile.localName"
            :serverName="uploadedFile.serverName"
            @change="updateUploadedFile"
          />
        </div>
      </div>
    </div>

    <div class="step-buttons">
      <button class="btn btn-primary" type="button" @click="prev()">
        Previous
      </button>
      <button
        :class="['btn', submitting ? 'btn-warning' : 'btn-primary']"
        :disabled="submitting"
        type="button"
        @click="submit()"
      >
        {{ submitting ? "Submitting" : "Submit" }}
      </button>
    </div>
  </div>
</template>

<script>
import "date-input-polyfill";
import { mapActions, mapState } from "vuex";
import ProgressBar from "./ProgressBar";
import FileUploader from "./FileUploader";
import formatCurrency from "@/util/formatCurrency";

export default {
  components: { ProgressBar, FileUploader },
  computed: {
    ...mapState([
      "five",
      "submitting",
      "other_structures",
      "outdoor_property",
      "loss_history",
      "uploadedFile",
    ]),
  },
  methods: {
    ...mapActions([
      "updateFormFive",
      "prevStep",
      "addStructure",
      "removeStructure",
      "updateStructure",
      "addProperty",
      "removeProperty",
      "updateProperty",
      "addLossHistoryItem",
      "updateLossHistoryItem",
      "removeLossHistoryItem",
      "updateUploadedFile",
      "submitData",
    ]),
    updateCurrency(key, val) {
      const processed = formatCurrency(val);
      this.updateField(key, processed);
    },
    updateField(key, val) {
      const updates = { [key]: val };
      this.updateFormFive(updates);
    },
    updateStructureName(index, value) {
      const structure = { ...this.other_structures[index], name: value };
      this.updateStructure({ index, structure });
    },
    updateStructureAmount(index, value) {
      const processed = formatCurrency(value);
      const structure = { ...this.other_structures[index], amount: processed };
      this.updateStructure({ index, structure });
    },
    updatePropertyName(index, value) {
      const property = { ...this.outdoor_property[index], name: value };
      this.updateProperty({ index, property });
    },
    updatePropertyAmount(index, value) {
      const processed = formatCurrency(value);
      const property = { ...this.outdoor_property[index], amount: processed };
      this.updateProperty({ index, property });
    },
    updateLossHistoryType(index, value) {
      const item = { ...this.loss_history[index], type: value };
      this.updateLossHistoryItem({ index, item });
    },
    updateLossHistoryAmount(index, value) {
      const processed = formatCurrency(value);
      const item = { ...this.loss_history[index], amount: processed };
      this.updateLossHistoryItem({ index, item });
    },
    updateLossHistoryDate(index, value) {
      const item = { ...this.loss_history[index], date: value };
      this.updateLossHistoryItem({ index, item });
    },
    prev() {
      window.scrollTo(0, 0);
      this.prevStep();
    },
    submit() {
      // check if file was uploaded
      if (this.uploadedFile.serverName) {
        this.submitData();
      } else {
        alert("Please upload a pdf utility bill.");
      }
    },
  },
};
</script>

<style>
.loss-history__item,
.other-structures__item,
.outdoor-properties__item {
  display: flex;
  align-items: center;
  margin-left: -2px;
  margin-right: -2px;
}
.loss-history__item > *,
.other-structures__item > *,
.outdoor-properties__item > * {
  margin: 2px;
}
@media (max-width: 767px) {
  .loss-history__item {
    flex-wrap: wrap;
  }
}
</style>
